import { AfterContentInit, Component, ElementRef, EventEmitter, Output, Renderer2, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'gcc-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false
})
export class SearchFieldComponent implements AfterContentInit {
  public input: HTMLInputElement;

  @Output() public apply: EventEmitter<string> = new EventEmitter();
  @Output() public clear: EventEmitter<void> = new EventEmitter();

  constructor(
    private eleRef: ElementRef,
    private renderer: Renderer2
  ) {}

  public ngAfterContentInit() {
    this.input = this.eleRef.nativeElement.querySelector('input');
  }

  public handleApply() {
    this.apply.emit(this.input.value);
  }

  public handleClear() {
    this.renderer.setValue(this.input, '');
    this.clear.emit();
  }
}
